import { observer } from 'mobx-react'
import React, { PropsWithChildren, useEffect } from 'react'
import { API_SUCCESS } from '@flowwai-frontend/shared/api-common'

import { useContactTemplate } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { LoadingWrapper } from '@flowwai-frontend/shared/common-components'
import useGetContactTemplate from '../../hooks/apis/GetContactTemplate/useGetContactTemplate'

const ContactTemplateAPIController = (props: PropsWithChildren) => {
   const getContactAPI = useGetContactTemplate()
   const { getContactTemplate } = useContactTemplate()

   const doNetworkCall = () => {
      try {
         getContactTemplate()
      } catch {
         getContactAPI.triggerAPI({})
      }
   }

   useEffect(() => {
      doNetworkCall()
   }, [])

   const getAPIStatus = () => {
      try {
         getContactTemplate()
         return API_SUCCESS
      } catch (error) {
         return getContactAPI.apiStatus
      }
   }

   return (
      <LoadingWrapper
         apiStatus={getAPIStatus()}
         apiError={getContactAPI.apiError}
         onRetry={doNetworkCall}
      >
         {props.children}
      </LoadingWrapper>
   )
}

export default observer(ContactTemplateAPIController)
